<template>
  <app-left-right>
    <template #left>
      <app-role-list @sendRole="sendRole"></app-role-list>
    </template>
    <template #right>
      <app-base-main noPadding>
        <template #filter-group>
          <template v-if="roleId === null"> </template>
          <template v-else>
            <el-tabs v-model="tabsModel" @tab-click="handleClick">
              <el-tab-pane label="角色用户" name="roleUser">
                <app-role-user :role-id="roleId"></app-role-user>
              </el-tab-pane>
              <el-tab-pane label="功能权限" name="source">
                <app-role-source :role-id="roleId"></app-role-source>
              </el-tab-pane>
              <el-tab-pane label="字段权限" name="field">
                <app-role-field-auth :role-id="roleId"></app-role-field-auth>
              </el-tab-pane>
            </el-tabs>
          </template>
        </template>
      </app-base-main>
    </template>
  </app-left-right>
  <!-- <div class="content">
        <div class="left-list">
            <app-role-list @sendRole="sendRole"></app-role-list>
        </div>
        <div class="body">
            <template v-if="roleId === null">

            </template>
            <template v-else>
                <el-tabs v-model="tabsModel" @tab-click="handleClick">
                    <el-tab-pane label="角色用户" name="roleUser">
                        <app-role-user :role-id="roleId"></app-role-user>
                    </el-tab-pane>
                    <el-tab-pane label="功能权限" name="source">
                        <app-role-source :role-id="roleId"></app-role-source>
                    </el-tab-pane>
                    <el-tab-pane label="字段权限" name="field">
                        <app-role-field-auth :role-id="roleId"></app-role-field-auth>
                    </el-tab-pane>
                </el-tabs>
              <div class="tool-group">
                <gj-tool-group help></gj-tool-group>
              </div>
            </template>
        </div>
    </div> -->
</template>

<script>
import AppRoleUser from "./component/role-user";
import AppRoleList from "./component/role-list";
import AppRoleFieldAuth from "./component/role-field-auth";
import AppRoleSource from "./component/role-source";
export default {
  name: "role",
  components: { AppRoleSource, AppRoleFieldAuth, AppRoleList, AppRoleUser },
  data() {
    return {
      tabsModel: "roleUser",
      roleId: null,
    };
  },
  methods: {
    handleClick() {},
    sendRole(roleId) {
      this.roleId = roleId;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .base-main_margin{
  height: 100%;
  margin-bottom: 0 !important;
}
/deep/ .el-tabs{
  height: 100%;
  display: flex;
  flex-direction: column;
  .el-tabs__content{
    flex: 1;
    overflow: auto;
  }
  .el-tab-pane{
    height: 100%;
  }
}
.content {
  display: flex;
  flex-direction: row;
  height: 100%;
}
.left-list {
  width: 250px;
  padding: 10px 0 16px 20px;
}
.body {
  flex: 1;
  background: white;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  margin: 10px 20px 16px 10px;
}
/deep/ .el-tabs__item {
  padding: 0 20px;
  height: 40px;
  box-sizing: border-box;
  line-height: 40px;
  display: inline-block;
  list-style: none;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  position: relative;
}
/deep/ .el-tabs__item.is-active {
  color: #1F6EEF;
}
/deep/ .el-checkbox {
  position: relative;
  cursor: pointer;
  white-space: nowrap;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-right: 30px;
}
/deep/ .right-container-bg{
  padding-top: 0;
}
</style>
